<template>
  <div id="app">
    <div class="logo" v-show="InnerWidth">
      <div class="Titfl">英特尔合作伙伴集结号 报表系统</div>
      <div><img class="img" src="./assets/intel-logo-highres.png"/></div>
      <div class="Titfr"><div v-if="!$route.meta.noLogn">{{`${username}（${$store.state.userData.memberOf}）`}}
        &nbsp&nbsp/&nbsp&nbsp
        <span @click="edit">退出</span>
      </div></div>
    </div>
    <div :style="!$route.meta.noLogn?'min-height:80vh;':''">
       <router-view v-if="isRouterAlive"/>
    </div>
     
    
    <div class="footer" v-if="!$route.meta.noLogn">
      <div class="navbar-collapse">
          <ul class="nav navbar-nav">
            <li><img style="height:42px;padding: 0 20px;" src="https://partnersocialtest.intel.cn/files/test/upload_image/ce1627_1577331710418_intel-logo-highres.png"/></li>
            <li>|<a class="navbar-footer-brand" href="#">©英特尔公司</a></li>
            <li> | <a>沪 ICP 备 18006294 号-1</a></li>
             <li> | <a href="http://www.intel.cn/content/www/cn/zh/legal/terms-of-use.html?iid=ftr%20terms" target="loginTerms">使用条款</a></li>
             <li>  | <a href="http://www.intel.cn/content/www/cn/zh/legal/trademarks.html" target="loginTrademarks">*商标</a></li>
             <li> |  <a href="http://www.intel.cn/content/www/cn/zh/privacy/intel-online-privacy-notice-summary.html" target="loginPrivacy">隐私条款</a></li>
             <li> |  <a href="http://www.intel.cn/content/www/cr/zh/privacy/intel-cookie-notice.html" target="loginCookies">Cookie</a></li>
          </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { formatUser } from '@/util/index'
import axios from "axios";
export default {
  name: "App",
  provide () {
    return {
      reload: this.reload,
    }
  },
  data() {
    return {
      InnerWidth: true,
      isRouterAlive: true, //用了刷新当前页面
      username:'',
      };
  },
  created() {
    if (innerWidth <= 750) {
      this.InnerWidth = false;
      return;
    }
    console.log('------------------App-----------------')
    this.$nextTick(function () {
      this.username=window.localStorage.getItem('displayname')
      formatUser()
    })
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    edit(e){
      
      localStorage.clear()
     
      // this.$router.push("/")
      setTimeout(() => {
        window.location.href="https://consumer.intel.com/intelcorpb2c.onmicrosoft.com/B2C_1A_UNIFIEDLOGIN_SISU_STD_SAML/generic/login?entityId=https://partnersocial.intel.cn/report/v2" 
        // window.open("https://partnersocial.intel.cn/report/",'_blank')
        // window.location.href="https://signin.intel.com/Logout" 
      }, 500);
      
      // window.open("https://signin.intel.com/Logout",'_blank')
    },
},
};
</script>
<style>
html,
body {
  width:100%;
  /* height: 100%; */
}
#app {
  width: 100%;
  height: 100%;
}
.logo {
  width: 100%;
  height: 60px;
  background-color: #0071c5;
  line-height: 58px;
  font-weight: 650;
  font-size: 21px;
  color: white;
  text-indent:1em;
  display: flex;
  justify-content: space-between;
    flex-wrap: nowrap;
    align-items:center ;

}
.logo .Titfl{
  display: inline;
  float: left;
  flex: 2;
}
.logo .Titfr{
  display: inline;
  text-align: right;
  font-size: 18px;
  font-weight: 400;
  padding-right: 80px;
  flex: 2;
}
.logo .Titfr span{
  cursor: pointer;
  /* text-decoration: underline; */
}
.img{
  height: 40px;
  padding: 9px 0;
  float: left;
}

/* .fixed{
  position: fixed;
  bottom: 0;
} */
.footer{
  background: #f3f3f3;
  color: #555555;
  padding:25px 0px;
  width: 100%;
  font-size: 20px;
}
.fl{float: left;}
.fr{float: right;margin-left: 100px;}
.navbar-collapse{
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  align-items:center ;
}
.navbar-nav{
  margin: 0 auto;
  display: block;
}
.navbar-nav li{font-size: 14px;
    text-align: right;
    /* padding: 0 40px; */
    float: left;

}
.navbar-nav>li>a {
    padding-top: 10px;
    padding-bottom: 10px;
    line-height: 42px;
    padding: 0 20px;
}
a {
    color: #555555;
    text-decoration: none;
    display: inline;
}
</style>



// WEBPACK FOOTER //
// src/App.vue